import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFloorLoading } from '../../../../store/slices/projectItemSlice';
import { setAllItems } from '../../../../store/slices/imageOverlaySlice';
import { setAllShapes } from '../../../../store/slices/drawingSlice';
import { loadImageItems } from './Drawing/drawingService';
import { useProjectHeader } from '../../../../pages/buildProject/Helpers/pageDiv/ProjectHeaderContext';

// The floor-plan fetch behind loadImageItems has no client-side timeout
// (see hooks/axiosClient.js), so a stalled request would otherwise leave
// floorLoading stuck at `true` forever - keeping the full-screen loading
// Overlay up and hiding everything drawn on the map (including navigation
// lines) until the user forces a re-fetch by switching floors. This caps
// how long we'll wait before clearing the overlay regardless.
const FLOOR_LOAD_TIMEOUT_MS = 12000;

const withTimeout = (promise, ms) =>
  Promise.race([
    promise,
    new Promise((resolve) => setTimeout(resolve, ms)),
  ]);

export default function FloorLoadingGate() {
  const dispatch     = useDispatch();
  const currentFloor = useSelector((s) => s.api.currentFloor);
  const floorId      = currentFloor?.enc_id ?? null;
  const versionRef   = useRef(0);
  const firstRun     = useRef(true);

  const { reset } = useProjectHeader();

  useEffect(() => { 
    if (!floorId) {
      dispatch(setFloorLoading(false));
      return;
    }
 
    if (firstRun.current) {
      firstRun.current = false;
    } else {
      dispatch(setAllItems([]));
      dispatch(setAllShapes([]));
    }

    versionRef.current += 1;
    const version = versionRef.current;

    withTimeout(loadImageItems(floorId).catch(() => null), FLOOR_LOAD_TIMEOUT_MS)
      .finally(() => {
        if (version === versionRef.current) {
          dispatch(setFloorLoading(false));
        }
      });
  }, [floorId, dispatch, reset]);

  return null;
}
